import { Injectable } from '@angular/core';

import { SessionStorage } from './storage/session';
import { StorageToken } from 'core/constants';

@Injectable({
    providedIn: 'root'
})
export class CimaStepUpErrorService {
    private sessionStorage: SessionStorage;

    constructor(sessionStorage: SessionStorage) {
        Object.assign(this, { sessionStorage });
    }

    public init(accQuery: string): void {
        if (accQuery) {
            this.sessionStorage.set(StorageToken.CIMA_STEP_UP_ERROR, accQuery);
        } 
    }
}

